// React
import React from "react";
// React
// CSS
import styles from "./MessageCard.module.css";
// CSS
// Models
import { I_NotificationMain } from "../../../../Models/interfaces";
// Models

import * as Farvardin from "farvardin";

type MessagesCardProps = {
  data: I_NotificationMain;
};

const MessageCard: React.FunctionComponent<MessagesCardProps> = ({
  data: {
    created_at,
    data: {
      data: { icon, message, title },
      date,
      type: _type,
    },
    id,
    notifiable_id,
    notifiable_type,
    read_at,
    type,
    updated_at,
  },
}) => {
  return (
    <div
      className={`${styles.messageCardContainer} relative w-full flex fle-row items-start justify-start px-4 mt-4 pt-4 pb-10 first-of-type:pt-0`}
    >
      <p
        className={`${styles.imgContainer} rounded-full w-20 h-20 p-1 flex items-center justify-center`}
      >
        <img src={icon} alt="" className="  " />
      </p>
      <p className="flex flex-col items-center justify-center pr-3 pt-2.5">
        <span className="text-base text-right w-full">{title}</span>
        <span className="text-right mt-2 text-sm">{message}</span>
      </p>
      <p className="absolute bottom-2 left-0 text-xs ">
        {((): React.ReactNode => {
          const seprate = created_at.split("T");
          const targetDate = created_at.split("T")[0].split("-");
          const targetTime = seprate[1].split(".")[0];
          const x = Farvardin.gregorianToSolar(
            Number(targetDate[0]),
            Number(targetDate[1]),
            Number(targetDate[2]),
            "string"
          );

          console.log(targetTime);
          return (
            <>
              <span>{x} </span>
              &nbsp;
              <span>{targetTime}</span>
            </>
          );
        })()}
      </p>
    </div>
  );
};

export default MessageCard;
